export default "__VITE_ASSET__CT8GgVaE__"